import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

import { Company } from '../../../types';
import { companyLinkInsuranceRules, companyPolicyExample } from '../../../constants/companies';
import { 
  BtsWrapper, 
  ButtonsWrapper, 
  AssistanceWrapper, 
  AsistanceTitle,
  AsistanceValue,
  Info 
} from '../style';

type Props = {
  company: Company;
}

const btnStyle = {
  height: '54px',
  fontSize: '12px',
  padding: '0'
}

const AssistanceAndButtons: React.FC<Props> = ({ company }) => {
  const { t } = useTranslation(); 
  const handleNavigateTo = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  return (
    <BtsWrapper>
      <AssistanceWrapper>
        <AsistanceTitle>{`${t('assistans')}`}:</AsistanceTitle>
        <AsistanceValue>Assistance AP Companies</AsistanceValue>
        <Info />
      </AssistanceWrapper>
      <ButtonsWrapper>
        <Button 
          variant='outlined' 
          type='button'
          onClick={() => handleNavigateTo(companyLinkInsuranceRules[company.name])} 
          startIcon={<InsertDriveFileOutlinedIcon />}
          sx={btnStyle}
        >
          {`${t('insurance_rules')}`}
        </Button>
        <Button 
          variant='outlined'
          type='button'
          onClick={() => handleNavigateTo(companyPolicyExample[company.name])}
          startIcon={<InsertDriveFileOutlinedIcon />}
          sx={btnStyle}
        >
          {`${t('insurance_policy')}`}
        </Button>
      </ButtonsWrapper>
    </BtsWrapper>
  );
};

export default AssistanceAndButtons;
